import { render, staticRenderFns } from "./SeedDetails.vue?vue&type=template&id=7c4668f8&scoped=true&"
import script from "./SeedDetails.vue?vue&type=script&lang=js&"
export * from "./SeedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4668f8",
  null
  
)

export default component.exports